import { AssetType } from '@amzn/fire-tv-campaign-automation-service';
import shell11InchLandscape from 'public/images/tablet-shells/FireTabletsFeatureRotator_11Inch_Landscape_FOS_Shell.png';
import {
  PreviewStateConfig,
  LayerType,
  BackgroundTransformType,
  LogoTransformType,
  GradientDirection,
} from 'src/utils/preview/types';

import {
  ALT_TEXT,
  SHIFT_FACTOR,
  GRADIENT_DARK,
  GRADIENT_TRANSPARENT,
  SCRIM_START,
  SCRIM_END,
  MAX_LINES,
  FONT_FAMILY,
  TEXT_COLOR,
} from '../constants';

export const TABLET_11INCH_LANDSCAPE_FOS: PreviewStateConfig = {
  label: '11" Landscape',
  altText: ALT_TEXT,
  dimensions: { width: 2000, height: 1200 },
  metadataZone: { top: 321, ctaTop: 742, safeZone: 70, leftMargin: 90 },
  layers: [
    {
      type: LayerType.BACKGROUND,
      transform: {
        type: BackgroundTransformType.CENTER_CROP,
        shiftFactor: SHIFT_FACTOR,
        x: 17,
        y: 321,
        width: 1966,
        height: 524,
      },
    },
    {
      type: LayerType.GRADIENT,
      direction: GradientDirection.HORIZONTAL,
      colorStops: [
        { position: 0, color: GRADIENT_DARK },
        { position: 1, color: GRADIENT_TRANSPARENT },
      ],
      bounds: { x: 17, y: 321, width: 983, height: 524 },
    },
    {
      type: LayerType.LOGO,
      transform: {
        type: LogoTransformType.FIT_WITHIN,
        maxWidth: 443,
        maxHeight: 180,
        position: { x: 160, y: 430 },
      },
    },
    {
      type: LayerType.TEXT,
      position: {
        x: 160,
        y: 676,
      },
      fontSize: 23,
      fontFamily: FONT_FAMILY,
      color: TEXT_COLOR,
      maxWidth: 750,
      maxLines: MAX_LINES,
      lineHeight: 30,
    },
    {
      type: LayerType.GRADIENT,
      direction: GradientDirection.VERTICAL,
      colorStops: [
        { position: 0, color: SCRIM_START },
        { position: 1, color: SCRIM_END },
      ],
      bounds: { x: 17, y: 321, width: 1966, height: 36 },
    },
    {
      type: LayerType.GRADIENT,
      direction: GradientDirection.VERTICAL,
      colorStops: [
        { position: 0, color: SCRIM_END },
        { position: 1, color: SCRIM_START },
      ],
      bounds: { x: 17, y: 791, width: 1966, height: 54 },
    },
    { type: LayerType.SHELL, src: shell11InchLandscape },
  ],
  assetRequirements: [AssetType.BACKGROUND_IMAGE, AssetType.LOGO],
};
